import { GalleryController } from "../../../components/gallery/controller.js";

export class UserPrivateMachineryView {
  constructor() {
    this.gallery = new GalleryController('app.userPrivateController.maquinaria.view');
  }

  renderMain() {
    return `
      <div class="user-header">
        <h1>Mis máquinas</h1>
      </div>
      `;
  }

  renderForm(_data) {
    let isNew = false;
    if (!_data) {
      _data = {};
      isNew = true;
    }
    let html = `
    <div class="form">
      <input type="hidden" id="maquinaria-idcod" value="${_data.idcod || ''}"> 
      <h2 class="mb0 ancho">Datos de mi máquina</h2>
      <div class="group sb">
        <div class="group">
          <b>Categoría</b>
          <select id="maquinaria-categoria" value="${_data.categoria || ''}"></select>
          <span id="maquinaria-categoria-error"></span>
        </div>
        <div class="group">
          <b>Título</b>
          <input type="text" id="maquinaria-titulo" value="${_data.titulo || ''}"> 
          <span id="maquinaria-titulo-error"></span>
        </div>
        <div class="group">
          <b>Descripción corta</b>
          <textarea id="maquinaria-resumen" rows="5">${_data.resumen || ''}</textarea> 
          <span id="maquinaria-resumen-error"></span>
        </div>
      </div>
      <div class="group">
        <b>Imágenes</b>
        ${this.gallery.create(_data.imagenes)}
      </div>
      <div class="group">
        <b>Kilómetros</b>
        <input type="number" id="maquinaria-kilometros" min="0" value="${_data.kilometros || '0'}"> 
        <span id="maquinaria-kilometros-error"></span>
      </div>
      ${app.userPrivateController.view.renderPriceOptions('maquinaria', _data, isNew)}

      <div class="group">
        <b>Marca</b>
        <input type="text" id="maquinaria-marca" value="${_data.marca || ''}"> 
        <span id="maquinaria-marca-error"></span>
      </div>

      <div class="group vertical">
        <div class="group">
          <b>Modelo</b>
          <input type="text" id="maquinaria-modelo" value="${_data.modelo || ''}"> 
          <span id="maquinaria-modelo-error"></span>
        </div>
        <div class="group">
          <b>Año</b>
          <input type="number" id="maquinaria-anio" min="1950" max="2026" value="${_data.anio || ''}"> 
          <span id="maquinaria-anio-error"></span>
        </div>
      </div>
      <div class="group">
        <b>Provincia</b>
        <select id="maquinaria-provincia" value="${_data.provincia || ''}" onchange="
        APICRUD.Location.Selector_LoadCities('maquinaria-localidad', this.value, '${_data.localidad}')
        "></select>
        <span id="maquinaria-provincia-error"></span>
      </div>
      <div class="group">
        <b>Localidad</b>
        <select id="maquinaria-localidad" value="${_data.localidad || ''}"></select>
        <span id="maquinaria-localidad-error"></span>
      </div>
      <div class="group span">
        <b>Descripción completa del máquina</b>
        <textarea id="maquinaria-descripcion" rows="10">${_data.descripcion || ''}</textarea> 
        <span id="maquinaria-descripcion-error"></span>
      </div>
    </div>

    <div class="form-footer">
      <button class="mt20" onclick="app.userPrivateController.maquinaria.save()">${_data.idcod ? 'Guardar cambios' : 'Crear máquina'}</button>
    `;

    if (_data.idcod) {
      html += `
        <button class="mt20 bg-red fr" onclick="app.userPrivateController.maquinaria.delete('${_data.titulo || ''}', '${_data.idcod || ''}')">Eliminar</button>
      `;
    }

    html += `
      <span id="maquinaria-status" class="mt20"></span>
    </div>
    `;

    return html;
  }

  renderItemCollection(_items) {
    let html = '';
    html += '<div class="content items">';

    if (_items.data.length > 0) {
      html = `
        <div class="user-header-content">
          <h1>Mis máquinas</h1>
          <button onclick="app.userPrivateController.maquinaria.new()">+ Nueva máquina</button>
        </div>
        <div class="content items">
          ${_items.data.map(i => this.renderItem(i)).join('')}
        </div>
        `;
    } else {
      html = `
        <div class="user-header-content">
          <h1>Mis máquinas</h1>
          <button onclick="app.userPrivateController.maquinaria.new()">+ Nueva máquina</button>
        </div>
        <p> No hay publicaciones, cree su primera máquina ahora. </p>
        <br>
        <button onclick="app.userPrivateController.maquinaria.new()">+ Crear mi primer máquina</button>
        `;
    }
    return html;
  }

  renderItem(_item) {
    let images = _item.imagenes;
    if (images && typeof images == 'string' && images.length > 0) {
      try {
        images = JSON.parse(images);
      } catch (error) {
        console.log(error, images);
      }
    }
    if (!Array.isArray(images)) {
      images = [];
    }
    return `
    <article>
      <div class="item pb20" onclick="app.userPrivateController.maquinaria.edit('${_item?.idcod}')">
        <img src="${images.length > 0 ? APICRUD.Image.GetUrl(images[0]) : ''}" alt="" onerror="this.src='/assets/img/service.webp'">
        <h1>${_item?.titulo || 'Sin título'}</h1>
        <p>${_item?.resumen || ''}</p>
      </div>
    </article>
  `;
  }

  renderDeleteConfirmation(_title, _idcod) {
    return ` <h2>¿Seguro desea eliminar el máquina <b class="cr">${_title}</b>?</h2>
      <button class="bg-red" onclick="app.userPrivateController.maquinaria.deleteConfirmation('${_idcod}')">Eliminar</button>
      <button class="fr" onclick="app.userPrivateController.maquinaria.deleteCancel()">Conservar</button>
      `;
  }
}
